const mainTitle = "Rick & Morty";
const mainSubtitle =
  "A simple Rick & Morty API to bring all the human characters to you without the hassle of searching...Enjoy!";

function SectionLarge() {
  return (
    <section className="section is-small rickbackground">
      <div className="columns">
        <div className="column">
          <h1 className="title is-1 is-spaced mainTitle">{mainTitle} </h1>
          <h2 className="subtitle subtitle-white">{mainSubtitle}</h2>
        </div>
        <div className="column"></div>
      </div>
    </section>
  );
}

export default SectionLarge;
